module.exports = __webpack_public_path__ + "download.png?62b8bede18ae84fea9e2770af85da59b";